import styles from './index.module.less';
import { Button, Input, message } from 'antd';
import Image from 'next/image';
import React, { useEffect, useState } from 'react';
import { postUsernameMonitorApi } from '@/lib/service/contont-monitor';
import { useTranslation } from 'react-i18next';
import { ga_logEvent } from '@/shared/ga';
import { EventName, EventNameSource } from '@/shared/event-types';
import { useRouter } from 'next/router';

const Index: React.FC<any> = ({ callBackName, loading, setLoading, setIsSearching, scrollToReverseSearchHeader }) => {
  const router = useRouter();
  const [username, setUsername] = useState('');
  const { t } = useTranslation();
  const handleSearch = async (searchUsername?: string, source?: string) => {
    if (loading) return;
    const usernameToSearch = searchUsername || username;
    if (!usernameToSearch) {
      message.error(t('Please enter a username'));
      return;
    }

    const eventSource = source || (router.asPath === '/content-monitoring' ? EventNameSource.contentMonitoring : EventNameSource.reverseUsernameSearch);
    ga_logEvent(EventName.input_reverse_username, { page_source: eventSource });

    // Show skeleton immediately (for INP < 200ms)
    const startTime = performance.now();
    setLoading(true);
    setIsSearching(true);

    // Monitor skeleton render performance
    requestAnimationFrame(() => {
      const renderTime = performance.now() - startTime;
      console.log(`⏱️ Username skeleton rendered in ${renderTime.toFixed(2)}ms`);
    });

    const res = await postUsernameMonitorApi({
      username: usernameToSearch,
    });
    setLoading(false);

    if (res.code === 0) {
      ga_logEvent(EventName.click_username_search, { page_source: eventSource });
      callBackName(res.data, 'reverse-username-search', usernameToSearch);
    } else {
      message.error(res.message);
      setIsSearching(false);
    }
  };

  const handleSearchClick = () => handleSearch();
  const handleSearchEnter = () => handleSearch();

  // 获取路由参数
  useEffect(() => {
    const { name } = router.query;
    if (name) {
      setUsername(name as string);
      if (scrollToReverseSearchHeader) {
        scrollToReverseSearchHeader();
      }
      handleSearch(name as string, EventNameSource.blogFeature);
      // 删除路由参数
      const url = new URL(window.location.href);
      url.searchParams.delete('name');
      window.history.replaceState({}, '', url.toString());
    }
  }, [router.query]);

  return (
    <div className={styles.container}>
      <div>
        <Input
          placeholder={t('Enter your username')}
          value={username}
          onChange={(e) => setUsername(e.target.value)}
          onPressEnter={handleSearchEnter}
        />
      </div>
      <div>
        <Button onClick={handleSearchClick} loading={loading}>
          <Image
            src="https://res-front.pumpsoul.com/prod-erasa/image/content-monitoring/btnRight.svg"
            alt="erasa"
            width={20}
            height={20}
            fetchPriority="high"
            priority
          ></Image>
          <span>{t('Search Now')}</span>
        </Button>
      </div>
    </div>
  );
};

export default Index;
